const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#3a658e',
                hover: '#399edc'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
